export const environment = {
  production: false,
  apiUrl: 'https://api-dev.stencas.si/api',
  matomo: {
    enabled: true,
    url: 'https://analytics-staging.stencas.si/',
    siteId: '1',
    dimensions: {
      searchFilters: 1,
    },
  },
  squalomail: {
    appId: '6865',
    id: '3',
  },
};
